<template>
    <div>
        <h1 class="About-FirstTitle">图集 | Album</h1>
        <p class="Notice">图片上传 & 功能更新中，即将更新相册（实验室、云大点滴）</p>
        <div class="Album" v-if="nowalbum === -1">
            <div class="Content">
                <div class="EP" v-for="content in album" :style="content.style" v-on:click="SingleView(content.id)">
                    <p class="Name"><b>{{ content.name }}</b> <i class="Date">({{ content.date }})</i></p>
                </div>
            </div>
        </div>
        <div class="Reback" title="返回相册" v-if="nowalbum !== -1" v-on:click="Reback"><i
            class="fa fa-angle-double-left"></i>
        </div>
        <div class="SingleAlbum" v-if="nowalbum !== -1">
            <div class="Singleimg" v-for="content in album[nowalbum].image"
                 :style='{backgroundImage:"url("+content.address+")"}' :title="content.name"
                 v-on:click="FullView(content.id,content.address)"></div>
        </div>
        <div class="Priviousimg" v-if="fullimg.state !== 'none'" v-on:click="PriviousImage(fullimg.id)"><i
            class="fa fa-angle-left"></i></div>
        <div class="Fulldiv" v-if="fullimg.state !== 'none'" v-on:click="RecoverView">
        </div>
        <div class="Nextimg" v-if="fullimg.state !== 'none'" v-on:click="NextImage(fullimg.id)"><i
            class="fa fa-angle-right"></i></div>
        <div class="Closeimg" v-if="fullimg.state !== 'none'" v-on:click="CloseImage"><i class="fa fa-close"></i></div>
        <img class="Fullimg" v-if="fullimg.state !== 'none'" :src="fullimg.src" v-on:click="JumpView()">
        <p class="Fullname" v-if="fullimg.state !== 'none'">{{ album[nowalbum].image[fullimg.id].name }}</p>
        <p class="FullNumber" v-if="fullimg.state !== 'none'">{{ album[nowalbum].image[fullimg.id].id + 1 }} /
            {{ album[nowalbum].image.length }}</p>
    </div>
</template>

<script>
var baseurl = "https://www.loveffc.cn/Source/Image/"
var music = {
    classname: "fa fa-play",
    state: "pause",
};
var album = [{
    id: 0,
    name: "YNU1406软件工程实验室",
    date: "2019.08.22-2022.07.01",
    location: "云南昆明",
    style: "background-image:url('" + baseurl + "1406/21毕业聚餐1.jpg')",
    image: [{
        id: 0,
        name: "19入学见面聚餐1",
        address: baseurl + "1406/19入学见面聚餐1.jpg"
    }, {
        id: 1,
        name: "19入学见面聚餐2",
        address: baseurl + "1406/19入学见面聚餐2.jpg"
    }, {
        id: 2,
        name: "19入学见面聚餐3",
        address: baseurl + "1406/19入学见面聚餐3.jpg"
    }, {
        id: 3,
        name: "20NASAC1",
        address: baseurl + "1406/20NASAC1.jpg"
    }, {
        id: 4,
        name: "20NASAC2",
        address: baseurl + "1406/20NASAC2.jpg"
    }, {
        id: 5,
        name: "20NASAC3",
        address: baseurl + "1406/20NASAC3.jpg"
    }, {
        id: 6,
        name: "21毕业合影1",
        address: baseurl + "1406/21毕业合影1.jpg"
    }, {
        id: 7,
        name: "21毕业合影2",
        address: baseurl + "1406/21毕业合影2.jpg"
    }, {
        id: 8,
        name: "21毕业合影3",
        address: baseurl + "1406/21毕业合影3.jpg"
    }, {
        id: 9,
        name: "21毕业聚餐1",
        address: baseurl + "1406/21毕业聚餐1.jpg"
    }, {
        id: 10,
        name: "21毕业聚餐2",
        address: baseurl + "1406/21毕业聚餐2.jpg"
    }, {
        id: 11,
        name: "21毕业聚餐3",
        address: baseurl + "1406/21毕业聚餐3.jpg"
    }, {
        id: 12,
        name: "21毕业聚餐4",
        address: baseurl + "1406/21毕业聚餐4.jpg"
    }, {
        id: 13,
        name: "22毕业合影1",
        address: baseurl + "1406/22毕业合影1.jpg"
    }, {
        id: 14,
        name: "22毕业合影2",
        address: baseurl + "1406/22毕业合影2.jpg"
    }, {
        id: 15,
        name: "22毕业合影3",
        address: baseurl + "1406/22毕业合影3.jpg"
    }, {
        id: 16,
        name: "22毕业合影6",
        address: baseurl + "1406/22毕业合影6.jpg"
    }, {
        id: 17,
        name: "22毕业合影7",
        address: baseurl + "1406/22毕业合影7.jpg"
    }, {
        id: 18,
        name: "22毕业聚餐1",
        address: baseurl + "1406/22毕业聚餐1.jpg"
    }, {
        id: 19,
        name: "22毕业聚餐2",
        address: baseurl + "1406/22毕业聚餐2.jpg"
    }, {
        id: 20,
        name: "22毕业聚餐3",
        address: baseurl + "1406/22毕业聚餐3.jpg"
    }, {
        id: 21,
        name: "22毕业聚餐4",
        address: baseurl + "1406/22毕业聚餐4.jpg"
    }, {
        id: 22,
        name: "郑明师兄毕业合影1",
        address: baseurl + "1406/郑明师兄毕业合影1.jpg"
    }, {
        id: 23,
        name: "Apple idea合影",
        address: baseurl + "1406/Apple idea合影.png"
    }]
},
    {
        id: 1,
        name: "CBPM2020",
        date: "2020.10.30-2020.11.01",
        location: "北京",
        style: "background-image:url('" + baseurl + "CBPM2020/会议当天.jpg')",
        image: [{
            id: 0,
            name: "会议当天",
            address: baseurl + "CBPM2020/会议当天.jpg"
        }, {
            id: 1,
            name: "合影1",
            address: baseurl + "CBPM2020/合影1.jpg"
        }, {
            id: 2,
            name: "合影2",
            address: baseurl + "CBPM2020/合影2.jpg"
        }, {
            id: 3,
            name: "合影3",
            address: baseurl + "CBPM2020/合影3.jpg"
        }, {
            id: 4,
            name: "合影4",
            address: baseurl + "CBPM2020/合影4.jpg"
        }, {
            id: 5,
            name: "合影5",
            address: baseurl + "CBPM2020/合影5.jpg"
        }, {
            id: 6,
            name: "合影6",
            address: baseurl + "CBPM2020/合影6.jpg"
        }, {
            id: 7,
            name: "昌龙1",
            address: baseurl + "CBPM2020/昌龙1.jpg"
        }, {
            id: 8,
            name: "昌龙2",
            address: baseurl + "CBPM2020/昌龙2.jpg"
        }, {
            id: 9,
            name: "吉祥1",
            address: baseurl + "CBPM2020/吉祥1.jpg"
        }, {
            id: 10,
            name: "吉祥2",
            address: baseurl + "CBPM2020/吉祥2.jpg"
        }, {
            id: 11,
            name: "吉祥3",
            address: baseurl + "CBPM2020/吉祥3.jpg"
        }, {
            id: 12,
            name: "我1",
            address: baseurl + "CBPM2020/我1.jpg"
        }, {
            id: 13,
            name: "我2",
            address: baseurl + "CBPM2020/我2.jpg"
        }, {
            id: 14,
            name: "我3",
            address: baseurl + "CBPM2020/我3.jpg"
        }, {
            id: 15,
            name: "幸福的笑容",
            address: baseurl + "CBPM2020/幸福的笑容.jpg"
        }, {
            id: 16,
            name: "北航外小酒馆1",
            address: baseurl + "CBPM2020/北航外小酒馆1.jpg"
        }, {
            id: 17,
            name: "北航外小酒馆2",
            address: baseurl + "CBPM2020/北航外小酒馆2.jpg"
        }, {
            id: 18,
            name: "强哥1",
            address: baseurl + "CBPM2020/强哥1.jpg"
        }, {
            id: 19,
            name: "海淀外",
            address: baseurl + "CBPM2020/海淀外.jpg"
        }]
    },
    {
        id: 2,
        name: "NASAC2020",
        date: "2020.11.20-2020.11.22",
        location: "重庆",
        style: "background-image:url('" + baseurl + "NASAC2020/磁器口.jpg')",
        image: [{
            id: 0,
            name: "21日晚磁器口游玩",
            address: baseurl + "NASAC2020/磁器口.jpg"
        }]
    },
    {
        id: 3,
        name: "竞赛获奖（省级及以上）",
        date: "Always",
        location: "University",
        style: "background-image:url('" + baseurl + "Award/2021中国大学生服务外包创新创业大赛总决赛二等奖.png')",
        image: [{
            id: 0,
            name: "2017年全国信息与软件人才大赛（蓝桥杯大赛）云南省省赛三等奖",
            address: baseurl + "Award/2017年全国信息与软件人才大赛（蓝桥杯大赛）云南省省赛三等奖.jpg"
        }, {
            id: 1,
            name: "2020中国大学生服务外包创新创业大赛中部区域赛三等奖",
            address: baseurl + "Award/2020中国大学生服务外包创新创业大赛中部区域赛三等奖.png"
        }, {
            id: 2,
            name: "2020中国高校计算机大赛-网络技术挑战赛西南赛区二等奖",
            address: baseurl + "Award/2020中国高校计算机大赛-网络技术挑战赛西南赛区二等奖.png"
        },
            {
                id: 3,
                name: "2020全国信息与软件人才大赛（蓝桥杯大赛）云南省省赛一等奖",
                address: baseurl + "Award/2020全国信息与软件人才大赛（蓝桥杯大赛）云南省省赛一等奖.png"
            }, {
                id: 4,
                name: "2020全国信息与软件人才大赛（蓝桥杯大赛）全国总决赛三等奖",
                address: baseurl + "Award/2020全国信息与软件人才大赛（蓝桥杯大赛）全国总决赛三等奖.png"
            }, {
                id: 5,
                name: "2020中国高校计算机大赛-网络技术挑战赛总决赛三等奖",
                address: baseurl + "Award/2020中国高校计算机大赛-网络技术挑战赛总决赛三等奖.png"
            }, {
                id: 6,
                name: "2020中国大学生软件测试大赛云南省省赛一等奖",
                address: baseurl + "Award/2020中国大学生软件测试大赛云南省省赛一等奖.jpg"
            }, {
                id: 7,
                name: "2021全国信息与软件人才大赛（蓝桥杯大赛）云南省省赛三等奖",
                address: baseurl + "Award/2021全国信息与软件人才大赛（蓝桥杯大赛）云南省省赛三等奖.jpg"
            }, {
                id: 8,
                name: "2021中国大学生服务外包创新创业大赛中部区域赛一等奖",
                address: baseurl + "Award/2021中国大学生服务外包创新创业大赛中部区域赛一等奖.jpg"
            }, {
                id: 9,
                name: "2021中国高校计算机大赛-网络技术挑战赛西南赛区三等奖",
                address: baseurl + "Award/2021中国高校计算机大赛-网络技术挑战赛西南赛区三等奖.jpg"
            }, {
                id: 10,
                name: "2021中国国际“互联网+”大学生创新创业大赛云南省省赛铜奖",
                address: baseurl + "Award/2021中国国际“互联网+”大学生创新创业大赛云南省省赛铜奖.png"
            }, {
                id: 11,
                name: "2021中国国际“互联网+”大学生创新创业大赛云南省省赛铜奖2",
                address: baseurl + "Award/2021中国国际“互联网+”大学生创新创业大赛云南省省赛铜奖2.png"
            }, {
                id: 12,
                name: "2021中国大学生服务外包创新创业大赛总决赛二等奖",
                address: baseurl + "Award/2021中国大学生服务外包创新创业大赛总决赛二等奖.png"
            }, {
                id: 13,
                name: "2022全国信息与软件人才大赛（蓝桥杯大赛）云南省省赛二等奖",
                address: baseurl + "Award/2022全国信息与软件人才大赛（蓝桥杯大赛）云南省省赛二等奖.jpg"
            }]
    }];
var nowalbum = -1;
var fullimg = {
    state: "none",
    id: -1,
    src: ""
};
export default {
    name: "Album",
    data() {
        return {
            music: music,
            album: album,
            nowalbum: nowalbum,
            fullimg: fullimg
        }
    },
    methods: {
        SingleView: function (albumid) {
            this.nowalbum = albumid;
        },
        Reback: function () {
            this.nowalbum = -1;
        },
        FullView: function (id, address) {
            this.fullimg.state = "block";
            this.fullimg.id = id;
            this.fullimg.src = address;
        },
        RecoverView: function () {
            this.fullimg.state = "none";
            this.fullimg.id = -1;
            this.fullimg.src = "";
        },
        PriviousImage: function (id) {
            if (id === 0) {
                this.fullimg.id = this.album[this.nowalbum].image.length - 1;
            } else {
                this.fullimg.id -= 1
            }
            this.fullimg.src = this.album[this.nowalbum].image[this.fullimg.id].address;
        },
        NextImage: function (id) {
            if (id === this.album[this.nowalbum].image.length - 1) {
                this.fullimg.id = 0;
            } else {
                this.fullimg.id += 1
            }
            this.fullimg.src = this.album[this.nowalbum].image[this.fullimg.id].address;
        },
        CloseImage: function () {
            this.fullimg.state = "none";
            this.fullimg.id = -1;
            this.fullimg.src = "";
        },
        JumpView: function () {
            window.location.href = this.fullimg.src;
        },
    }
}
</script>

<style src="../assets/StyleSheet/Album.css" scoped>
</style>
<style src="../assets/StyleSheet/About.css" scoped>
</style>